<template>
  <v-form ref="refForm" v-model="valid" :validate-on="validateOn" @submit.prevent="handleSubmit">
    <slot />
  </v-form>
</template>

<script>
export default {
  name: "Form",

  props: {
    onAction: {
      type: Function,
      default: null,
    },
    validateOn: {
      type: String,
      default: "blur",
    },
  },

  data() {
    return {
      valid: false,
      tristateButtons: [],
      telFields: [],
      selectionButtons: [],
    };
  },

  provide() {
    return {
      registerTriStateButtons: (component) => this.registerTriStateButtons(component),
      unregisterTriStateButtons: (component) => this.unregisterTriStateButtons(component),
      validateTriStates: () => this.validateTriStates(),

      registerTelField: (component) => this.registerTelField(component),
      unregisterTelField: (component) => this.unregisterTelField(component),
      validateTelFields: () => this.validateTelFields(),

      registerSelectionCards: (component) => this.registerSelectionCards(component),
      unregisterSelectionCards: (component) => this.unregisterSelectionCards(component),
      validateSelectionCards: () => this.validateSelectionCards(),
    };
  },

  methods: {
    handleSubmit(event) {
      if (this.onAction) {
        event.preventDefault();
        this.onAction();
      }
    },

    //TriState Buttons
    registerTriStateButtons(component) {
      this.tristateButtons.push(component);
    },

    unregisterTriStateButtons(component) {
      this.tristateButtons = this.tristateButtons.filter((btn) => btn !== component);
    },

    validateTriStates() {
      let isValid = true;
      this.tristateButtons.forEach((button) => {
        const result = button.validate();
        if (!result) {
          isValid = false;
        }
      });
      return isValid;
    },

    //Tel Fields
    registerTelField(component) {
      this.telFields.push(component);
    },

    unregisterTelField(component) {
      this.telFields = this.telFields.filter((field) => field !== component);
    },

    validateTelFields() {
      let isValid = true;
      this.telFields.forEach((field) => {
        const result = field.validate();
        if (!result) {
          isValid = false;
        }
      });
      return isValid;
    },

    //Selection Buttons
    registerSelectionCards(component) {
      this.selectionButtons.push(component);
    },

    unregisterSelectionCards(component) {
      this.selectionButtons = this.selectionButtons.filter((btn) => btn !== component);
    },

    validateSelectionCards() {
      let isValid = true;
      this.selectionButtons.forEach((button) => {
        const result = button.validate();
        if (!result) {
          isValid = false;
        }
      });
      return isValid;
    },

    //Form
    async validateForm() {
      const formValidation = await this.$refs.refForm.validate();
      const triStateValidation = this.validateTriStates();
      const telFieldValidation = this.validateTelFields();
      const selectionButtonsValidation = this.validateSelectionCards();
      return formValidation.valid && triStateValidation && telFieldValidation && selectionButtonsValidation;
    },

    resetValidation() {
      if (this.$refs.refForm) {
        this.$refs.refForm.resetValidation();
      }
    },
  },
};
</script>
